// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__xT8Lt","resendInfoText":"OnGoingPaymentBox_resendInfoText__2GHno"};